import {createSelector} from 'reselect';
import {createResourceSelector} from 'src/shared/utils/resource';

export const rawLocationSuggestions = createResourceSelector('locationSuggestions');

export const locationSuggestions = createSelector(
  rawLocationSuggestions,
  rawLocationSuggestions =>
    rawLocationSuggestions
      .filter(x => x.length > 2)
      .slice(0, 8)
);
